// vue components
import ShipDetail from './vue/components/_ship-detail.vue';
import Krpano from "vue-krpano";
import TravelListItem from "./vue/components/_travel-list-item.vue";
import TravelGallery from "./vue/components/_travel-gallery.vue";

Vue.component('ship-detail', ShipDetail);
Vue.component('travel-list-item', TravelListItem);
Vue.component('travel-gallery', TravelGallery);
Vue.component('krpano', Krpano);